import React from 'react';
import { ROUTES } from '../Constants';
import SapthahBanner from '../images/sapthah-banner.webp';
import KvbBanner2021 from '../images/karkidaka-vavubali-2021-01.webp';
import KvbBanner2023 from '../images/karkidaka-vavubali-2023-01.webp';
import SapthahBanner2026 from '../images/Saptah-2026-10x4-1x.png';

const EventsPage = () => {
    return (
        <>
            <div className='container mx-auto'>
                <h1 className='text-xl lg:text-2xl font-bold text-gray-800 mt-6 mb-6 text-center'>Events</h1>
                <div class="flex flex-wrap justify-center mt-10">
                    <div class="p-4 max-w-sm">
                        <div class="flex rounded-lg h-full bg-orange-300 flex-col">
                            <img src={KvbBanner2021}
                                alt="Karkidaka Vavu Bali 2021" class="h-80 w-100 object-cover rounded-t" />
                            <div class="flex items-center mb-3 px-4 py-4">
                                <div
                                    class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full dark:bg-indigo-500 bg-indigo-500 text-white flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                                    </svg>
                                </div>
                                <h2 class="text-black text-lg font-medium">Karkidaka Vavu Bali 2021</h2>
                            </div>
                            <div class="flex flex-col justify-between flex-grow p-4">
                                <p class="leading-relaxed text-base text-black">
                                    Glimpses from Karkidaka Vavu Bali event from the year 2021.
                                </p>
                                <a href="." class="mt-3 text-black hover:text-blue-600 inline-flex items-center">Learn More
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                        <path d="M5 12h14M12 5l7 7-7 7"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 max-w-sm">
                        <div class="flex rounded-lg h-full bg-orange-300 flex-col">
                            <img src={KvbBanner2023}
                                alt="Karkidaka Vavu Bali 2023" class="h-80 w-100 object-cover rounded-t" />
                            <div class="flex items-center mb-3 px-4 py-4">
                                <div
                                    class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full dark:bg-indigo-500 bg-indigo-500 text-white flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                                    </svg>
                                </div>
                                <h2 class="text-black text-lg font-medium">Karkidaka Vavu Bali 2023</h2>
                            </div>
                            <div class="flex flex-col justify-between flex-grow p-4">
                                <p class="leading-relaxed text-base text-black">
                                    Glimpses from Karkidaka Vavu Bali event from the year 2023.
                                </p>
                                <a href="." class="mt-3 text-black hover:text-blue-600 inline-flex items-center">Learn More
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                        <path d="M5 12h14M12 5l7 7-7 7"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 max-w-sm">
                        <div class="flex rounded-lg h-full bg-orange-300 flex-col">
                            <img src={KvbBanner2023}
                                alt="Karkidaka Vavu Bali 2024" class="h-80 w-100 object-cover rounded-t" />
                            <div class="flex items-center mb-3 px-4 py-4">
                                <div
                                    class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full dark:bg-indigo-500 bg-indigo-500 text-white flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                                    </svg>
                                </div>
                                <h2 class="text-black text-lg font-medium">Karkidaka Vavu Bali 2024</h2>
                            </div>
                            <div class="flex flex-col justify-between flex-grow p-4">
                                <p class="leading-relaxed text-base text-black">
                                    Glimpses from Karkidaka Vavu Bali event from the year 2024.
                                </p>
                                <a href="." class="mt-3 text-black hover:text-blue-600 inline-flex items-center">Learn More
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                        <path d="M5 12h14M12 5l7 7-7 7"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 max-w-sm">
                        <div class="flex rounded-lg h-full bg-orange-300 flex-col">
                            <img src={SapthahBanner}
                                alt="Sreemadh Bhagavatha Sapthahayajnam" class="h-80 w-100 object-cover rounded-t" />
                            <div class="flex items-center mb-3 px-4 py-4">
                                <div
                                    class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full dark:bg-indigo-500 bg-indigo-500 text-white flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                                    </svg>
                                </div>
                                <h2 class="text-black text-lg font-medium">Sreemadh Bhagavatha Sapthahayajnam</h2>
                            </div>
                            <div class="flex flex-col justify-between flex-grow p-4">
                                <p class="leading-relaxed text-base text-black">
                                    ശ്രീമദ് ഭാഗവത സപ്താഹയജ്ഞം - കിളിപ്പാട്ട്, 06.09.2024 to 12.09.2024, (കൊല്ല വർഷം 1200, ചിങ്ങം 21 - 27) Ayyappa Devasthanam, Kamalanagar, ECIL.
                                </p>
                                <a href={ROUTES.BHAGAVATHA_SAPTAH} class="mt-3 text-black hover:text-blue-600 inline-flex items-center">Learn More
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                        <path d="M5 12h14M12 5l7 7-7 7"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 max-w-sm">
                        <div class="flex rounded-lg h-full bg-orange-300 flex-col">
                            <img src={KvbBanner2023}
                                alt="Karkidaka Vavu Bali 2025" class="h-80 w-100 object-cover rounded-t" />
                            <div class="flex items-center mb-3 px-4 py-4">
                                <div
                                    class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full dark:bg-indigo-500 bg-indigo-500 text-white flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                                    </svg>
                                </div>
                                <h2 class="text-black text-lg font-medium">Karkidaka Vavu Bali 2025</h2>
                            </div>
                            <div class="flex flex-col justify-between flex-grow p-4">
                                <p class="leading-relaxed text-base text-black">
                                    Glimpses from Karkidaka Vavu Bali event from the year 2025.
                                </p>
                                <a href="." class="mt-3 text-black hover:text-blue-600 inline-flex items-center">Learn More
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                        <path d="M5 12h14M12 5l7 7-7 7"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 max-w-sm">
                        <div class="flex rounded-lg h-full bg-orange-300 flex-col">
                            <img src={KvbBanner2023}
                                alt="Karkidaka Vavu Bali 2025" class="h-80 w-100 object-cover rounded-t" />
                            <div class="flex items-center mb-3 px-4 py-4">
                                <div
                                    class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full dark:bg-indigo-500 bg-indigo-500 text-white flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                                    </svg>
                                </div>
                                <h2 class="text-black text-lg font-medium">Karkidaka Vavu Bali 2026</h2>
                            </div>
                            <div class="flex flex-col justify-between flex-grow p-4">
                                <p class="leading-relaxed text-base text-black">
                                    Glimpses from Karkidaka Vavu Bali event from the year 2026.
                                </p>
                                <a href="." class="mt-3 text-black hover:text-blue-600 inline-flex items-center">Learn More
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                        <path d="M5 12h14M12 5l7 7-7 7"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 max-w-sm">
                        <div class="flex rounded-lg h-full bg-orange-300 flex-col">
                            <img src={SapthahBanner2026}
                                alt="Sreemadh Bhagavatha Sapthahayajnam" class="h-80 w-100 object-cover rounded-t" />
                            <div class="flex items-center mb-3 px-4 py-4">
                                <div
                                    class="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full dark:bg-indigo-500 bg-indigo-500 text-white flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                                    </svg>
                                </div>
                                <h2 class="text-black text-lg font-medium">Sreemadh Bhagavatha Sapthahayajnam</h2>
                            </div>
                            <div class="flex flex-col justify-between flex-grow p-4">
                                <p class="leading-relaxed text-base text-black">
                                    ശ്രീമദ് ഭാഗവത സപ്താഹയജ്ഞം - കിളിപ്പാട്ട്, 27.09.2026 to 03.10.2026, (കൊല്ലവർഷം 1202 കന്നി 11 - 17) Ayyappa Devasthanam, Kamalanagar, ECIL.
                                </p>
                                <a href={ROUTES.BHAGAVATHA_SAPTAH} class="mt-3 text-black hover:text-blue-600 inline-flex items-center">Learn More
                                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                        <path d="M5 12h14M12 5l7 7-7 7"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default EventsPage;